import { PropsWithChildren } from 'react';

import wellhubLogo from 'assets/images/wellhub.svg';

import * as S from './styles';

export default function Template({ children }: PropsWithChildren) {
  return (
    <S.Container>
      <S.Content>
        <S.Logo width={130} height={24} alt="Wellhub" src={wellhubLogo} />
        <S.Panel>{children}</S.Panel>
      </S.Content>
    </S.Container>
  );
}
